<template>
    <div class="flex items-center gap-2">
        <input
            :id="checkboxId"
            ref="checkbox"
            type="checkbox"
            :checked="value"
            @change="emitChange"
            class="rounded-sm border-2 border-black w-4 h-4 font-semibold"
        >

        <label
            :for="checkboxId"
            class="text-[12px] font-light font-oceanside"
        >
            <slot />
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            checkboxId: {
                type: String,
                required: true,
            },

            value: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            emitChange() {
                this.$emit('checkboxChecked', this.$refs.checkbox.checked);
            },
        },
    };
</script>
